// extracted by mini-css-extract-plugin
module.exports = {"articleVoice__title":"ArticleVoiceItemsBlock_articleVoice__title__A5PrM","articleVoice__button":"ArticleVoiceItemsBlock_articleVoice__button__dxfnY"};